'use client';

export default function PhoneLink(props: { phoneString: string; phoneLink: string }) {
    //@eslint-disable
    const isMobile = window.navigator.userAgent.toLowerCase().includes('mobi');

    return (
        <>
            {isMobile ? (
                <a aria-label={`Call ${props.phoneLink}`} href={`tel:${props.phoneLink}`}>
                    {props.phoneString}
                </a>
            ) : (
                <span className="text-sm">{props.phoneString}</span>
            )}
        </>
    );
}
